import { Injectable } from '@angular/core';
import { NodeAnnotation, NodeTag } from '../models/graph-viewer.models';

export const TAG_META: Record<NodeTag, { label: string; color: string; dot: string }> = {
  confirmed: { label: 'Confirmed', color: '#22c55e', dot: '#22c55e' },
  review: { label: 'Needs verification', color: '#f59e0b', dot: '#f59e0b' },
  false_positive: { label: 'False positive', color: '#ef4444', dot: '#ef4444' },
};

@Injectable({ providedIn: 'root' })
export class GraphAnnotationsService {
  private readonly storageKey = 'osint-link-analysis-annotations';
  private annotations: Record<string, NodeAnnotation> = this.load();

  getAnnotations(): Record<string, NodeAnnotation> {
    return this.annotations;
  }

  getAnnotation(nodeId: string): NodeAnnotation {
    return this.annotations[nodeId] ?? {};
  }

  setTag(nodeId: string, tag: NodeTag | undefined): void {
    const cur = { ...(this.annotations[nodeId] ?? {}) };
    if (tag === undefined) {
      delete cur.tag;
    } else {
      cur.tag = tag;
    }
    this.commit(nodeId, cur);
  }

  setNote(nodeId: string, note: string): void {
    const cur = { ...(this.annotations[nodeId] ?? {}) };
    if (note.trim()) {
      cur.note = note;
    } else {
      delete cur.note;
    }
    this.commit(nodeId, cur);
  }

  private commit(nodeId: string, cur: NodeAnnotation): void {
    const next = { ...this.annotations };
    if (!cur.tag && !cur.note) {
      delete next[nodeId];
    } else {
      next[nodeId] = cur;
    }
    this.annotations = next;
    this.persist();
  }

  private load(): Record<string, NodeAnnotation> {
    if (typeof localStorage === 'undefined') return {};
    try {
      const raw = localStorage.getItem(this.storageKey);
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }

  private persist(): void {
    if (typeof localStorage === 'undefined') return;
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.annotations));
    } catch {
      /* ignore quota errors */
    }
  }
}
